import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { apiService } from '../../../../../service/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators, ValidatorFn, FormGroupDirective, NgForm, FormBuilder } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { StorageService } from 'src/app/service/storage.service';
@Component({
  selector: 'app-modal-cambiar-pass',
  templateUrl: './modal-cambiar-pass.component.html',
  styleUrls: ['./modal-cambiar-pass.component.css']
})
export class ModalCambiarPassComponent implements OnInit {

  
  form: FormGroup;
  matcher = new MyErrorStateMatcher();
  incorrecta = false;
  constructor(
    private api: apiService,    
    private formBuilder: FormBuilder, 
    public storageService: StorageService,   
    private router: Router, 
    public dialogRef: MatDialogRef<ModalCambiarPassComponent>,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      antigua: ['',[Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['']
  }, { validator: this.checkPasswords })
  }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;

    return pass === confirmPass ? null : { notSame: true }
  }
  confirmar(){
    let json= {
      idUsuario: this.storageService.getCurrentUser().idUsuario,
      passAnterior: this.form.controls['antigua'].value,
      passNueva: this.form.controls['password'].value
    }
    this.api.API_POST_cambiarPass(json).subscribe((response) => {
      this.validar(response);
    },
    (err) => {
      console.log(err)
    })
  }

  validar(data){
    if(data.payload.resultado === "error"){
      this.incorrecta = true;
    }else{
      this.dialogRef.close();      
    }
  }

  validarIncorrecta(){
    if(this.incorrecta){
      this.incorrecta = false;
    }
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}